function HomeHeaderSlideshow(el) {
    this.el = el;
    this.progressEl = this.el.querySelector('.jsHomeHeaderProgress');
    this.slideWrapperEl = this.el.querySelector('.jsHomeHeaderSlides');
    this.slideEls = this.slideWrapperEl.querySelectorAll('.jsHomeHeaderSlides .jsSlide');
    this.currentSlideIndex = 0;
    this.slideTimeout = 7000;

    // Project intro
    this.projectIntroEl = this.el.querySelector('.jsProjectIntro');
    this.projectIntroTitleEl = this.projectIntroEl.querySelector('.jsProjectTitle');
    this.projectIntroLinkEl = this.projectIntroEl.querySelector('.jsProjectLink');

    // Set the current slide video aspect ratio
    const currentSlideVideoEl = this.slideEls[0].querySelector('video');
    if (currentSlideVideoEl) this.setVideoAspectRatio(currentSlideVideoEl);

    // Add resize listeners for the current slide video
    window.addEventListener('resize', () => {
        const currentSlideVideoEl = this.slideEls[this.currentSlideIndex].querySelector('video');
        if (currentSlideVideoEl) this.setVideoAspectRatio(currentSlideVideoEl);
    });
    
    // Start the autoslide interval
    this.restartProgressBar();
    setInterval(() => this.nextSlide(), this.slideTimeout);
}

HomeHeaderSlideshow.prototype.restartProgressBar = function() {
    gsap.timeline()
        .set(this.progressEl, { width: 0, opacity: 1 })
        .to(this.progressEl, { duration: (this.slideTimeout / 1000) - 0.4, width: '100%', ease: Power2.easeInOut })
        .to(this.progressEl, { duration: 0.3, opacity: 0, ease: Power2.easeInOut })
    ;
};

HomeHeaderSlideshow.prototype.nextSlide = function() {
    const currentSlideEl = this.slideEls[this.currentSlideIndex];
    const nextSlideIndex = (this.currentSlideIndex + 1) > (this.slideEls.length - 1) ? 0 : this.currentSlideIndex + 1;
    const nextSlideEl = this.slideEls[nextSlideIndex];

    this.restartProgressBar();

    if (!nextSlideEl) return;

    const nextSlideVideoEl = nextSlideEl.querySelector('video');

    gsap.timeline()
        .set(nextSlideEl, { opacity: 0, display: 'block' })
        .add(() => {
            nextSlideEl.classList.add('next');
            this.setVideoAspectRatio(nextSlideVideoEl);
        })

        .to(this.projectIntroTitleEl, { duration: 0.5, y: -5, opacity: 0, ease: 'power2.inOut' })
        .to(nextSlideEl, { duration: 0.5, opacity: 1, ease: 'power2.inOut' }, '-=0.5')

        .set(this.projectIntroTitleEl, { y: 5 })

        .add(() => {
            this.projectIntroTitleEl.innerHTML = nextSlideEl.dataset.projectTitle;
            this.projectIntroLinkEl.href = nextSlideEl.dataset.projectUrl;
        })

        .to(this.projectIntroTitleEl, { duration: 0.5, y: 0, opacity: 1, ease: 'power2.inOut' })

        .add(() => {
            currentSlideEl.classList.remove('visible');
            nextSlideEl.classList.add('visible');
            nextSlideEl.classList.remove('next');
        })
        .set([currentSlideEl, nextSlideEl], { clearProps: 'display,opacity' })
    ;
 
    this.currentSlideIndex = nextSlideIndex;
};

HomeHeaderSlideshow.prototype.setVideoAspectRatio = function(videoEl) {
    if (videoEl !== null) {
        this.setVideoWidthHeight(videoEl);
        window.addEventListener('resize', () => this.setVideoWidthHeight(videoEl));

        if (document.readyState === 'complete') gsap.to(videoEl, 0.5, { opacity: 1, ease: 'power2.inOut' })
        else window.addEventListener('load', () => gsap.to(videoEl, 0.5, { opacity: 1, ease: 'power2.inOut' }));
    }
};

HomeHeaderSlideshow.prototype.getVideoWidthHeight = function() {
    const aspectRatio = 16 / 9;

    const windowWidth = window.innerWidth;
    const windowHeight = this.el.offsetHeight;

    let videoWidth = windowWidth;
    let videoHeight = windowWidth / aspectRatio;

    if (windowHeight > videoHeight) {
        videoHeight = windowHeight;
        videoWidth = videoHeight * aspectRatio;
    }

    return [videoWidth, videoHeight];
};

HomeHeaderSlideshow.prototype.setVideoWidthHeight = function(videoEl) {
    const videoWidthHeight = this.getVideoWidthHeight();

    videoEl.style.width = videoWidthHeight[0] + 'px';
    videoEl.style.height = videoWidthHeight[1] + 'px';
};